export const CARD_PACK_SHOP_ABI = [
  // ── Single pack opening ───────────────────────────────────────────────────
  {
    inputs: [
      { internalType: "uint8", name: "tier",     type: "uint8" },
      { internalType: "uint8", name: "payToken", type: "uint8" },
    ],
    name: "openPack",
    outputs: [
      { internalType: "uint256", name: "packId", type: "uint256" },
      { internalType: "uint256", name: "seed",   type: "uint256" },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint8", name: "tier",     type: "uint8" },
      { internalType: "uint8", name: "payToken", type: "uint8" },
    ],
    name: "openPackHV",
    outputs: [
      { internalType: "uint256", name: "packId", type: "uint256" },
      { internalType: "uint256", name: "seed",   type: "uint256" },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint8",   name: "tier",      type: "uint8"   },
      { internalType: "uint8",   name: "payToken",  type: "uint8"   },
      { internalType: "bytes32", name: "codeHash",  type: "bytes32" },
    ],
    name: "openPackWithPromo",
    outputs: [
      { internalType: "uint256", name: "packId", type: "uint256" },
      { internalType: "uint256", name: "seed",   type: "uint256" },
    ],
    stateMutability: "payable",
    type: "function",
  },
  // ── Gift a pack to another wallet ─────────────────────────────────────────
  {
    inputs: [
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint8",   name: "tier",      type: "uint8"   },
      { internalType: "uint8",   name: "payToken",  type: "uint8"   },
    ],
    name: "giftPack",
    outputs: [
      { internalType: "uint256", name: "packId", type: "uint256" },
      { internalType: "uint256", name: "seed",   type: "uint256" },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint8",   name: "tier",      type: "uint8"   },
      { internalType: "uint8",   name: "payToken",  type: "uint8"   },
    ],
    name: "giftPackHV",
    outputs: [
      { internalType: "uint256", name: "packId", type: "uint256" },
      { internalType: "uint256", name: "seed",   type: "uint256" },
    ],
    stateMutability: "payable",
    type: "function",
  },
  // ── Batch pack opening ────────────────────────────────────────────────────
  {
    inputs: [
      { internalType: "uint8", name: "tier",     type: "uint8" },
      { internalType: "uint8", name: "payToken", type: "uint8" },
      { internalType: "uint8", name: "count",    type: "uint8" },
    ],
    name: "openPackBatch",
    outputs: [{ internalType: "uint256", name: "firstPackId", type: "uint256" }],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint8", name: "tier",     type: "uint8" },
      { internalType: "uint8", name: "payToken", type: "uint8" },
      { internalType: "uint8", name: "count",    type: "uint8" },
    ],
    name: "openPackBatchHV",
    outputs: [{ internalType: "uint256", name: "firstPackId", type: "uint256" }],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint8",   name: "tier",     type: "uint8"   },
      { internalType: "uint8",   name: "payToken", type: "uint8"   },
      { internalType: "uint8",   name: "count",    type: "uint8"   },
      { internalType: "bytes32", name: "codeHash", type: "bytes32" },
    ],
    name: "openPackBatchWithPromo",
    outputs: [{ internalType: "uint256", name: "firstPackId", type: "uint256" }],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "recipient", type: "address" },
      { internalType: "uint8",   name: "tier",      type: "uint8"   },
      { internalType: "uint8",   name: "payToken",  type: "uint8"   },
      { internalType: "uint8",   name: "count",     type: "uint8"   },
    ],
    name: "giftPackBatch",
    outputs: [{ internalType: "uint256", name: "firstPackId", type: "uint256" }],
    stateMutability: "payable",
    type: "function",
  },
  // ── Sell-back & shipment ──────────────────────────────────────────────────
  {
    inputs: [
      { internalType: "uint256", name: "packId",          type: "uint256" },
      { internalType: "uint8",   name: "refundToken",     type: "uint8"   },
      { internalType: "uint256", name: "cardValueUsd18",  type: "uint256" },
      { internalType: "bytes",   name: "valueSignature",  type: "bytes"   },
    ],
    name: "sellBack",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "cardValueUsd18", type: "uint256" },
      { internalType: "uint8",   name: "refundToken",    type: "uint8"   },
    ],
    name: "previewSellback",
    outputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  // ── GEM cashout ───────────────────────────────────────────────────────────
  {
    inputs: [
      { internalType: "uint256", name: "gemAmount",   type: "uint256" },
      { internalType: "uint8",   name: "payoutToken", type: "uint8"   },
    ],
    name: "cashoutGems",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "gemAmount",   type: "uint256" },
      { internalType: "uint8",   name: "payoutToken", type: "uint8"   },
    ],
    name: "previewGemCashout",
    outputs: [{ internalType: "uint256", name: "payoutAmt", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "packId",               type: "uint256" },
      { internalType: "bytes",   name: "encryptedShippingInfo", type: "bytes"   },
    ],
    name: "requestShipment",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  // ── Price views ───────────────────────────────────────────────────────────
  {
    inputs: [
      { internalType: "uint8", name: "tier",  type: "uint8" },
      { internalType: "uint8", name: "token", type: "uint8" },
    ],
    name: "packPrice",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint8",   name: "tier",     type: "uint8"   },
      { internalType: "uint8",   name: "payToken", type: "uint8"   },
      { internalType: "bytes32", name: "codeHash", type: "bytes32" },
      { internalType: "address", name: "buyer",    type: "address" },
    ],
    name: "packPriceWithPromo",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint8", name: "payToken", type: "uint8" }],
    name: "tokenUsdPrice",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  // ── Pack record ───────────────────────────────────────────────────────────
  {
    inputs: [{ internalType: "uint256", name: "packId", type: "uint256" }],
    name: "getPack",
    outputs: [
      {
        components: [
          { internalType: "address", name: "opener",         type: "address" },
          { internalType: "address", name: "giftedBy",       type: "address" },
          { internalType: "uint8",   name: "tier",           type: "uint8"   },
          { internalType: "uint8",   name: "payToken",       type: "uint8"   },
          { internalType: "bool",    name: "highVolatility", type: "bool"    },
          { internalType: "bool",    name: "soldBack",       type: "bool"    },
          { internalType: "bool",    name: "shipped",        type: "bool"    },
          { internalType: "uint256", name: "amountPaid",     type: "uint256" },
          { internalType: "uint256", name: "seed",           type: "uint256" },
          { internalType: "uint256", name: "timestamp",      type: "uint256" },
        ],
        internalType: "struct CardPackShop.PackRecord",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "packCount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  // ── Analytics & stats ─────────────────────────────────────────────────────
  {
    inputs: [],
    name: "getPackStats",
    outputs: [
      { internalType: "uint256",    name: "total",   type: "uint256"    },
      { internalType: "uint256[7]", name: "byTier",  type: "uint256[7]" },
      { internalType: "uint256[5]", name: "byToken", type: "uint256[5]" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "packsOpenedBy",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    name: "tierMaxSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    name: "tierSupplyUsed",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  // ── Contract state ────────────────────────────────────────────────────────
  {
    inputs: [],
    name: "paused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "jackpotInterval",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "jackpotGemMult",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dailyBonusGem",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gemEventMultiplier",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxBatchSize",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function",
  },
  // ── Daily bonus ───────────────────────────────────────────────────────────
  {
    inputs: [],
    name: "claimDailyBonus",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "canClaimDailyBonus",
    outputs: [
      { internalType: "bool",    name: "canClaim",    type: "bool"    },
      { internalType: "uint256", name: "nextClaimAt", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  // ── Promo codes ───────────────────────────────────────────────────────────
  {
    inputs: [{ internalType: "bytes32", name: "codeHash", type: "bytes32" }],
    name: "getPromoInfo",
    outputs: [
      { internalType: "uint256", name: "discountBps", type: "uint256" },
      { internalType: "uint256", name: "maxUses",     type: "uint256" },
      { internalType: "uint256", name: "usedCount",   type: "uint256" },
      { internalType: "uint256", name: "expiry",      type: "uint256" },
      { internalType: "bool",    name: "active",      type: "bool"    },
    ],
    stateMutability: "view",
    type: "function",
  },
  // ── Referral ──────────────────────────────────────────────────────────────
  {
    inputs: [{ internalType: "address", name: "referrer", type: "address" }],
    name: "setReferrer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "code", type: "bytes32" }],
    name: "setReferrerByCode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes32", name: "code", type: "bytes32" }],
    name: "setReferralCode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "affiliate", type: "address" }],
    name: "affiliateRates",
    outputs: [
      { internalType: "uint16", name: "t1Bps", type: "uint16" },
      { internalType: "uint16", name: "t2Bps", type: "uint16" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "affiliate", type: "address" }],
    name: "getReferralStats",
    outputs: [
      { internalType: "uint256", name: "tier1Count",  type: "uint256" },
      { internalType: "uint256", name: "tier2Count",  type: "uint256" },
      { internalType: "uint256", name: "totalEarned", type: "uint256" },
      { internalType: "uint256", name: "claimable",   type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint8", name: "payoutToken", type: "uint8" }],
    name: "claimReferralEarnings",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "n", type: "uint256" }],
    name: "getReferralLeaderboard",
    outputs: [
      {
        components: [
          { internalType: "address", name: "affiliate",   type: "address" },
          { internalType: "uint256", name: "totalEarned", type: "uint256" },
          { internalType: "uint256", name: "count",       type: "uint256" },
        ],
        internalType: "struct CardPackShop.LeaderEntry[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "myReferralCode",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "referrers",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  // ── Admin withdrawals ─────────────────────────────────────────────────────
  {
    inputs: [
      { internalType: "address", name: "token",  type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "address", name: "to",     type: "address" },
    ],
    name: "withdrawToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "token", type: "address" },
      { internalType: "address", name: "to",    type: "address" },
    ],
    name: "withdrawAllToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "amount", type: "uint256" },
      { internalType: "address", name: "to",     type: "address" },
    ],
    name: "withdrawNative",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "to", type: "address" }],
    name: "withdrawAllNative",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getBalances",
    outputs: [
      { internalType: "uint256", name: "busdcBal",  type: "uint256" },
      { internalType: "uint256", name: "wbnbBal",   type: "uint256" },
      { internalType: "uint256", name: "wethBal",   type: "uint256" },
      { internalType: "uint256", name: "gemBal",    type: "uint256" },
      { internalType: "uint256", name: "nativeBal", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  // ── Config getters (public state vars) ───────────────────────────────────
  { inputs: [], name: "t1FeeBps",     outputs: [{ internalType: "uint16",  name: "", type: "uint16"  }], stateMutability: "view", type: "function" },
  { inputs: [], name: "t2FeeBps",     outputs: [{ internalType: "uint16",  name: "", type: "uint16"  }], stateMutability: "view", type: "function" },
  { inputs: [], name: "sellbackBps",  outputs: [{ internalType: "uint256", name: "", type: "uint256" }], stateMutability: "view", type: "function" },
  { inputs: [], name: "referralPool", outputs: [{ internalType: "uint256", name: "", type: "uint256" }], stateMutability: "view", type: "function" },
  // ── Admin config ──────────────────────────────────────────────────────────
  {
    inputs: [
      { internalType: "uint8",   name: "payToken", type: "uint8"   },
      { internalType: "address", name: "oracle",   type: "address" },
    ],
    name: "setOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  // ── Events ────────────────────────────────────────────────────────────────
  {
    anonymous: false,
    inputs: [
      { indexed: true,  internalType: "address", name: "opener",         type: "address" },
      { indexed: true,  internalType: "uint256", name: "packId",         type: "uint256" },
      { indexed: false, internalType: "uint8",   name: "tier",           type: "uint8"   },
      { indexed: false, internalType: "uint8",   name: "payToken",       type: "uint8"   },
      { indexed: false, internalType: "uint256", name: "amountPaid",     type: "uint256" },
      { indexed: false, internalType: "uint256", name: "seed",           type: "uint256" },
      { indexed: false, internalType: "bool",    name: "highVolatility", type: "bool"    },
      { indexed: false, internalType: "address", name: "giftedBy",       type: "address" },
    ],
    name: "PackOpened",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true,  internalType: "address", name: "buyer",       type: "address" },
      { indexed: true,  internalType: "address", name: "recipient",   type: "address" },
      { indexed: false, internalType: "uint256", name: "firstPackId", type: "uint256" },
      { indexed: false, internalType: "uint8",   name: "count",       type: "uint8"   },
      { indexed: false, internalType: "uint8",   name: "tier",        type: "uint8"   },
      { indexed: false, internalType: "uint8",   name: "payToken",    type: "uint8"   },
    ],
    name: "PacksBatchOpened",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true,  internalType: "address", name: "opener",      type: "address" },
      { indexed: true,  internalType: "uint256", name: "packId",      type: "uint256" },
      { indexed: false, internalType: "uint8",   name: "refundToken", type: "uint8"   },
      { indexed: false, internalType: "uint256", name: "refundAmt",   type: "uint256" },
    ],
    name: "SoldBack",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true,  internalType: "address", name: "opener",               type: "address" },
      { indexed: true,  internalType: "uint256", name: "packId",               type: "uint256" },
      { indexed: false, internalType: "bytes",   name: "encryptedShippingInfo", type: "bytes"   },
    ],
    name: "ShipRequested",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true,  internalType: "address", name: "winner",    type: "address" },
      { indexed: true,  internalType: "uint256", name: "packId",    type: "uint256" },
      { indexed: false, internalType: "uint256", name: "gemBonus",  type: "uint256" },
    ],
    name: "JackpotWon",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true,  internalType: "address", name: "user",      type: "address" },
      { indexed: false, internalType: "uint256", name: "gemAmount", type: "uint256" },
    ],
    name: "DailyBonusClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true,  internalType: "address", name: "affiliate",   type: "address" },
      { indexed: false, internalType: "uint8",   name: "payoutToken", type: "uint8"   },
      { indexed: false, internalType: "uint256", name: "payoutAmt",   type: "uint256" },
    ],
    name: "ReferralClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true,  internalType: "address",  name: "user", type: "address"  },
      { indexed: false, internalType: "bytes32",  name: "code", type: "bytes32"  },
    ],
    name: "ReferralCodeSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true,  internalType: "address", name: "user",        type: "address" },
      { indexed: false, internalType: "uint256", name: "gemBurned",   type: "uint256" },
      { indexed: false, internalType: "uint8",   name: "payoutToken", type: "uint8"   },
      { indexed: false, internalType: "uint256", name: "payoutAmt",   type: "uint256" },
    ],
    name: "GemCashedOut",
    type: "event",
  },
] as const;

// ERC20 approve ABI (minimal)
export const ERC20_ABI = [
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "amount",  type: "uint256" },
    ],
    name: "approve",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "owner",   type: "address" },
      { internalType: "address", name: "spender", type: "address" },
    ],
    name: "allowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
] as const;
